
import React from 'react';
import ReactDOM from 'react-dom';
import swal from 'sweetalert';

class PromosEdit extends React.Component
{
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.save = this.save.bind(this);
        this.renderProductsOptions = this.renderProductsOptions.bind(this);

        this.state = {
            promo: {},
            products: [],
            successUpdate: false,
            token: ""
        };
    }

    componentWillMount()
    {
        let self = this;
        let id = self.props.id_promo;
        let token = self.props.csrf_token;

        self.setState({
            token: token
        });


        axios.get('/api/promos/details/' + id)
            .then(response => {
                self.setState({
                    promo: response.data
                });
            })
            .catch(error => {
                swal({
                    title: "¡Oh no!",
                    text: "Ha ocurrido un error al intentar procesar tu solicitud.",
                    icon: "warning",
                });
            });

        axios.get('/api/products/list/' + project)
            .then(response => {
                self.setState({
                    products: response.data
                });
            })
            .catch(error => {
            });

    }

    componentDidMount()
    {
        let self = this;
    }


    handleChange({target})
    {
        let self = this;

        let promo = self.state.promo;
        promo[target.id] = target.value;

        self.setState({
            promo: promo
        });
    }

    save()
    {
        let self = this;

        let request = self.state.promo;

        axios.post('/api/promos/update', request)
            .then(response => {
                location.reload();
            })
            .catch(error => {
            });
    }

    renderProductsOptions(item)
    {
        return(
            <option key={item.id} value={item.id}>
                {item.key}
            </option>
        );
    }

    setPromoStatus(status)
    {
        let self = this;
        let promo = self.state.promo;

        promo.status = status;

        self.setState({
            promo: promo
        });
    }

    setPromoType(status)
    {
        let self = this;
        let promo = self.state.promo;

        promo.type = status;

        self.setState({
            promo: promo
        });
    }

    render()
    {
        let self = this;

        return (
            <div>
                <div className="col-md-6">
                    <div className="col-sm-12">
                        <h4 className="page-title">Editar una promoción</h4>
                        <ol className="breadcrumb">
                            <li>
                                <a href="/">Home</a>
                            </li>
                            <li>
                                <a href="/promos">Promos</a>
                            </li>
                            <li className="active">
                                Editar
                            </li>
                        </ol>
                    </div>
                    <div className="col-md-6" style={{ paddingLeft: "0px" }}>
                        <div className="panel panel-default">
                            <div className={"panel-header"}>
                            </div>
                            <div className="panel-body">
                                <div className="col-md-12">
                                    <h4 className="m-t-0 header-title"><b>Editar una Promoción</b></h4>
                                    <br/>
                                    <form role="form" id="promosForm">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor="name">Nombre</label>
                                                    <input typeof="text" className="form-control" id="name"
                                                           onChange={this.handleChange}
                                                           value={this.state.promo.name} />
                                                </div>

                                                <div className="form-group">
                                                    <label htmlFor="description">Descripción</label>
                                                    <input typeof="text" className="form-control" id="description"
                                                           onChange={this.handleChange}
                                                           value={this.state.promo.description} />
                                                </div>

                                                <div className="form-group">
                                                    <label htmlFor="message">Descripción 2</label>
                                                    <input typeof="text" className="form-control" id="message"
                                                           onChange={this.handleChange}
                                                           value={this.state.promo.message} />
                                                </div>

                                                <div className="form-group">
                                                    <label htmlFor="id_product">Producto</label>
                                                    <select className="form-control" id="id_product" onChange={this.handleChange}
                                                            value={this.state.promo.id_product} >
                                                        <option value={""}>Selecciona un producto</option>
                                                        {this.state.products.map(this.renderProductsOptions)}
                                                    </select>
                                                </div>


                                                <div className="form-group">
                                                    <label htmlFor="id_product">Tipo</label>
                                                    <select className="form-control" id="promo_type" onChange={this.handleChange}
                                                            value={this.state.promo.promo_type}>
                                                        <option value={""}>Selecciona un tipo de promoción</option>
                                                        <option value={"phone"}>Telefonía</option>
                                                        <option value={"others"}>Otro</option>
                                                    </select>
                                                </div>

                                                {
                                                    (typeof this.state.promo.promo_type !== 'undefined' && this.state.promo.promo_type === 'phone') &&
                                                    <div className="form-group">
                                                        <label htmlFor="id_product">Tipo Telefonía</label>
                                                        <select className="form-control" id="promo_subtype" onChange={this.handleChange}
                                                                value={this.state.promo.promo_subtype}>
                                                            <option value={""}>Selecciona un sub-tipo</option>
                                                            <option value={"minutes"}>Minutos</option>
                                                            <option value={"internet"}>Megas para navegar</option>
                                                        </select>
                                                    </div>
                                                }

                                                <div className="form-group">
                                                    <label htmlFor="terms">Términos y condiciones</label>
                                                    <input typeof="text" className="form-control" id="terms"
                                                           onChange={this.handleChange}
                                                           value={this.state.promo.terms} />
                                                </div>

                                                <div className="form-group">
                                                    <label htmlFor="no_codes">Códigos asignables por usuario</label>
                                                    <input type="number" className="form-control" id="no_codes"
                                                           onChange={this.handleChange}
                                                           value={this.state.promo.no_codes} />
                                                </div>

                                                <div className="form-group">
                                                    <label htmlFor="no_codes">Número máximo de códigos canjeables</label>
                                                    <input type="number" className="form-control" id="max_exchangeable_codes"
                                                           onChange={this.handleChange}
                                                           value={this.state.promo.max_exchangeable_codes} />
                                                </div>

                                                <div className="form-group">
                                                    <label htmlFor="campaign_key_ws">Key de campaña</label>
                                                    <input type="text" className="form-control" id="campaign_key_ws"
                                                           onChange={this.handleChange}
                                                           value={this.state.promo.campaign_key_ws}/>
                                                </div>

                                                <div className="form-group">
                                                    <label htmlFor="mount_ws">Monto</label>
                                                    <input type="number" className="form-control" id="mount_ws"
                                                           onChange={this.handleChange}
                                                           value={this.state.promo.mount_ws}/>
                                                </div>

                                                <div className="form-group">
                                                    <label htmlFor="notes">Notas</label>
                                                    <textarea className="form-control" id="notes"
                                                              onChange={this.handleChange} value={this.state.promo.notes} />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label>Status</label>
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <button type="button" onClick={this.setPromoStatus.bind(this, 1)}
                                                                    className={"btn btn-block " + (parseInt(self.state.promo.status) ? "btn-success" : "btn-white") + " waves-effect waves-light"}>
                                                                <i className="fa fa-check"></i> Activa
                                                            </button>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <button type="button" onClick={this.setPromoStatus.bind(this, 0)}
                                                                    className={"btn btn-block " + (!parseInt(self.state.promo.status) ? "btn-warning" : "btn-white") + " waves-effect waves-light"}>
                                                                <i className="fa fa-times"></i> Inactiva
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <label>Tipo</label>
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <button type="button" onClick={this.setPromoType.bind(this, 0)}
                                                                    className={"btn btn-block " + (parseInt(self.state.promo.type) === 0? "btn-success" : "btn-white") + " waves-effect waves-light"}>
                                                                <i className="fa fa-users"></i> Pública
                                                            </button>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <button type="button" onClick={this.setPromoType.bind(this, 1)}
                                                                    className={"btn btn-block " + (parseInt(self.state.promo.type) === 1 ? "btn-warning" : "btn-white") + " waves-effect waves-light"}>
                                                                <i className="fa fa-user"></i> General
                                                            </button>
                                                        </div>
                                                        <div className="col-md-12">
                                                            <br/>
                                                            <button type="button" onClick={this.setPromoType.bind(this, 2)}
                                                                    className={"btn btn-block " + (parseInt(self.state.promo.type) === 2 ? "btn-info" : "btn-white") + " waves-effect waves-light"}>
                                                                <i className="fa fa-credit-card"></i> Exclusiva DESCLUB
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <hr/>
                                                    <small className="text-center">Para efectuar los cambios, da clic en el botón "Guardar"</small>
                                                </div>
                                            </div>
                                            <button type="button" className="btn btn-purple waves-effect waves-light"
                                                    id="promosRegisterButton" onClick={this.save}
                                                    disabled={!self.state.promo.description || !self.state.promo.id_product || !self.state.promo.no_codes || !self.state.promo.max_exchangeable_codes}>
                                                <i className="fa fa-save"></i> Guardar
                                            </button>

                                            {
                                                this.state.successRegister &&
                                                <div>
                                                    <a href="/promos" className="btn btn-success waves-effect waves-light">
                                                        <i className="fa fa-arrow-circle-o-left"></i> Regresar
                                                    </a>
                                                </div>
                                            }

                                        </div>
                                    </form>

                                </div>
                            </div>

                        </div>

                    </div>

                    <div className="col-md-6">
                        <div className="panel panel-default">
                            <div className={"panel-header"}>
                            </div>
                            <div className="panel-body">
                                <div className="col-md-12">

                                    <label>Imagen actual</label>
                                    <br/>
                                    <img src={this.state.promo.url_image} style={{ width: "100%"}} className="img-responsive" />
                                    <br/>

                                    <div className="text-center"></div>
                                    <label>Documento actual</label>
                                    <br/>
                                    <p>De clic en el siguiente botón para descargar el archivo de términos y condiciones</p>
                                    <br/>
                                    <div className="text-center">
                                        <a href={this.state.promo.terms_file_url}>
                                            <button className="btn btn-info">
                                                <i className="fa fa-download"></i> Descargar
                                            </button>
                                        </a>
                                    </div>
                                    <br/>
                                    <hr/>
                                    <form id="promoFilesForm" method="post" encType="multipart/form-data"
                                          action={"/promos/files/" + this.state.promo.id}>
                                        <input type="hidden" id="_token" name="_token" value={this.state.token}
                                               onChange={this.handleChange}/>
                                        <div className="form-group">
                                            <label htmlFor="promoImg">Imagen para la promoción</label>
                                            <input type="file" className="form-control" id="promoImg" name="promoImg" />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="promoImg">Documento Términos y Condiciones</label>
                                            <input type="file" className="form-control" id="promoTermsFile" name="promoTermsFile" />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="promoImg">Imágen para formulario</label>
                                            <input type="file" className="form-control" id="promoCheckoutImage" name="promoCheckoutImage" />
                                        </div>
                                        <button type="submit" className="btn btn-success">
                                            <i className="fa fa-refresh"></i> Actualizar
                                        </button>
                                    </form>


                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <div className="col-md-5 col-md-offset-1">
                    <h4 className="page-title">Vista preliminar</h4>
                    <p className="text-muted ">De esta forma es como el cliente verá la promoción</p>

                    <div className="">
                        <div className="panel panel-default">
                            <div className="panel-body">
                                <div className="col-md-12">
                                    <div className="col-md-4">
                                        <img className="img-responsive" src={self.state.promo.url_image} />
                                        <br/>
                                    </div>
                                    <div className="col-md-8">
                                        <h1 style={{ fontWeight: "bold" }}>{self.state.promo.name}</h1>
                                        <h3 style={{ fontWeight: "normal" }}>{self.state.promo.description}</h3>
                                        <h3 style={{ fontWeight: "normal" }}>{self.state.promo.message}</h3>
                                        <h5>{self.state.promo.terms}</h5>
                                        <br/>
                                        <div className="col-md-8 col-md-offset-2">
                                            <button className="btn btn-success btn-lg btn-block">
                                                ¡Lo quiero!
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

export default PromosEdit;

if (document.getElementById('promos_edit-component')) {
    ReactDOM.render(<PromosEdit id_promo={id_promo} csrf_token={csrf_token} />, document.getElementById('promos_edit-component'));
}



// WEBPACK FOOTER //
// ./resources/assets/react/PromosEdit.jsx